//@ts-nocheck 
export var thisclass = {
    containerfield: function(args) {

        var mainDiv = document.createElement("div");
        //mainDiv.className = "containerfieldborder";
        mainDiv.setAttribute("hdd", "0");

        if (args.p) {
            mainDiv.style.padding = "0";
            mainDiv.payloadTarget = mainDiv;
        } else {
            var header = mainDiv.appendChild(document.createElement("div"));
            var caption = header.appendChild(document.createElement("span"));
            var content = mainDiv.appendChild(document.createElement("div"));
            mainDiv.payloadTarget = content;

            caption.innerHTML = args.c;
            caption.classList.add("-ct");
            header.classList.add("-cth");
            content.classList.add("-con");
        }

        mainDiv.payloadTarget.classList.add("monocolumnresize"); //allows to resize on monocolumns only
        //mainDiv.payloadTarget.setAttribute("ect", args.ect);

        window.ood(args.i, mainDiv);
        this.setChildCount(args.i,args.ect);
    },

    setChildCount: function(id,count) {
        var item = window.oos(id);
        item.payloadTarget.setAttribute("ect", count);
        item.setAttribute("ect", count);
    },


    builder: function(args) {
        var fld = document.createElement("div");
        fld.classList.add("-sec");

        var ncaption = fld.appendChild(document.createElement("div"));
        ncaption.classList.add("-sec-caption");
        if (args.hdd === 0) ncaption.style.display = "none";


        var def = ncaption.appendChild(document.createElement("div"));
        def.classList.add("-tool");
        def.classList.add("icon-wrench");
        //def.className = "builderTool icon-wrench";
        //def.style.backgroundColor = "#EEEEEE";

        def.onclick = function() { window.jsE(args.id, "config"); };


        var caption = ncaption.appendChild(document.createElement("input"));
        caption.classList.add("-input");
        //caption.className = "containerinput";
        caption.value = args.caption;
        caption.addEventListener('input', () => jsE(args.id, "caption" + caption.value));
        var section = fld.appendChild(document.createElement("div"));
        section.classList.add("-pld");
        fld.payloadTarget = section;
        window.ood(args.id, fld);

    }
}

